export interface ISearchingTag {
    id: number;
    tagType: TagType;
    value: string;
    externalValue?: string;
    tagName?: TagName;
    suggestions?: string[];
}

export enum TagType {
    OpeningTag = 0,
    ClosingTag = 1,
    OperationTag = 2,
}

export enum TagName {
    Date = 0,
    Channel = 1,
    Operator = 2,
    Contact = 3,
    Phrase = 4,
    Status = 5,
    ChatNumber = 6,
    ChatTag = 7,
    ChannelName = 8,
    Setting = 9,

    Phone = 12,
    ChatName = 13,
    ContactName = 14,
    ContactExernalId = 15,
    OperatorType = 16,
    ChatType = 17,
    MessengerExternalId = 18,
    MessengerNickname = 19,

    TriggerName = 100,
    Subject = 101,
    Source = 102,
    Answer =103
}

export interface ISearchingTagApi {
    Name: number;
    Operator: number;
    Value: string;
}
